import { ComponentService } from "../Services/Axios/Api";

// Model for HTML blocks
export default class HTML {
  data = {};
  constructor() {
    this.data = {
      id: '',
      ComponentName: 'HTML',
      name: 'My HTML Block',
      description: '',
      htmlContent: '',
    };
  }

  // ID
  getId() { return this.data.id; }
  setId(id) { this.data.id = id; }

  // Component Name
  getComponentName() { return this.data.ComponentName; }
  setComponentName(name) { this.data.ComponentName = name; }

  // Name
  getName() { return this.data.name; }
  setName(name) { this.data.name = name; }

  // Description
  getDescription() { return this.data.description; }
  setDescription(description) { this.data.description = description; }

  // HTML Content
  getHtmlContent() { return this.data.htmlContent; }
  setHtmlContent(htmlContent) { this.data.htmlContent = htmlContent; }

  // Data operations
  getData() { return this.data; }
  setData(data) { this.data = data; }

  async load(id) {
    try {
      if (id) {
        const response = await ComponentService.getComponentById(id);
        const data = response.data ? JSON.parse(response.data) : {};
        this.setData(data);
        this.setId(response.id);
      } else {
        const response = await ComponentService.getComponent(this.data.ComponentName);
        const data = response[0]?.data ? JSON.parse(response[0]?.data) : {};
        this.setData(data);
        this.setId(response[0]?.id);
      }
      return this.data;
    } catch (error) {
      throw new Error(error.response?.data || 'Failed to load HTML block data');
    }
  }

  async save() {
    try {
      const response = await ComponentService.SaveData(this.getId(), this.getData());
      return response;
    } catch (error) {
      throw new Error(error.response?.data || 'Failed to save HTML block data');
    }
  }
}

export const createHTMLInstance = () => new HTML();
